// extracted by mini-css-extract-plugin
export default {"topSpacer":"FilterListComponent_topSpacer__-jE+0","icon-inner":"FilterListComponent_icon-inner__3PIVa"};